export const navigation = {
  it: {
    home: "Home",
    about: "Chi Sono",
    solutions: "Soluzioni",
    blog: "Blog",
    testimonials: "Testimonianze",
    contact: "Contatti",
    legal: {
      terms: "Termini",
      privacy: "Privacy",
      cookies: "Cookie"
    }
  },
  en: {
    home: "Home",
    about: "About",
    solutions: "Solutions",
    blog: "Blog",
    testimonials: "Testimonials",
    contact: "Contact",
    legal: {
      terms: "Terms",
      privacy: "Privacy",
      cookies: "Cookies"
    }
  }
}; 